import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {LOOKUPS, LOOKUPS_API_URL, GET_ALL_LOOKUPS_API_URL} from 'constants/AppConstants';
import { USER_All_INFORMATION } from "constants/AuthConstant";
import CommonService from 'services/CommonService/CommonService';
import IntlMessage from "components/util-components/IntlMessage";
const setLocale = (localeKey, isLocaleOn = true) =>
  isLocaleOn ? <IntlMessage id={localeKey} /> : localeKey.toString();
const permission = JSON.parse(localStorage.getItem(USER_All_INFORMATION));

export const initialState = {
  LookupsErrors       : {},
  permission: permission?.lookups ?? [],
  LookupsShowMessage  : null,
  LookupsResult       : [],
  LookupsButtonSpinner : false,
  LookupsTableLoading : true,
  LookupsAddDrawer    : false,
  LookupsEditData     : [],
  LookupsButtonAndModelLabel  : setLocale('lookups.add'),
  tablePagination: {
        current: 1,
        pageSize: 10,
        total: 0,
    },
    sorting: {},
    filter: {},
    ViewLookupsData: [],
    ViewLookupsLoader: true,
    DrawerStatus: 0,
};

export const createLookups = createAsyncThunk(
    "createLookups",
  async (data) => {
    try {
      const response = await CommonService.createAndUpdate(data, LOOKUPS_API_URL);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors)); // Throw an error with the server response errors
    }
  }
);

export const getLookups = createAsyncThunk(
    "getLookups",
  async (data) => {
    try {
      const response = await CommonService.getAllPost(data, GET_ALL_LOOKUPS_API_URL);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors)); // Throw an error with the server response errors
    }
  }
);

export const viewLookups = createAsyncThunk(
  "viewLookups",
  async (id) => {
    try {
      const response = await CommonService.showOne(id, LOOKUPS_API_URL);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors)); // Throw an error with the server response errors
    }
  }
);

export const deleteLookups = createAsyncThunk(
  "deleteLookups",
  async (data) => {
    try {
      const response = await CommonService.deleteOne(data, LOOKUPS_API_URL);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors)); // Throw an error with the server response errors
    }
  }
);

export const manageLookupsSlice = createSlice({
  name: LOOKUPS,
  initialState,
  reducers: {
    onCloseError: (state, action) => {
      state.LookupsErrors = {};
    },
    LookupsAddDrawerStatus: (state, action) => {
        if (action.payload.status === false) {
            state.LookupsButtonSpinner = false;
      }
      state.LookupsAddDrawer   = action.payload.status;
      state.DrawerStatus = action.payload.errorStatus;
      state.LookupsEditData    = [];
      state.LookupsButtonAndModelLabel = setLocale('lookups.add');
    },
    LookupsEditWithDrawerStatus: (state, action) => {
      state.LookupsAddDrawer = true;
      state.DrawerStatus = action.payload.errorStatus;
      state.LookupsEditData = action.payload.data;
      state.LookupsButtonAndModelLabel = setLocale('lookups.edit');
    },
    updateSortFilters: (state, action) => {
        state.filter = action.payload.filter;
        state.sorting = action.payload.sorting;
    },
    setColumnSearch: (state, action) => {
      state.filter = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createLookups.pending, (state, action) => {
        state.DrawerStatus = 0
        state.LookupsButtonSpinner = true;
      }).addCase(createLookups.fulfilled, (state, action) => {
        state.DrawerStatus = 0
        state.LookupsButtonSpinner = false;
        state.LookupsErrors = {}
      }).addCase(createLookups.rejected, (state, action) => {
        state.DrawerStatus = 1
        state.LookupsShowMessage = true;
        state.LookupsButtonSpinner = false;
        state.LookupsErrors = JSON.parse(action.error.message); // Parse the error messages and store them in the state
      }).addCase(getLookups.pending, (state, action) => {
        state.LookupsButtonSpinner = true;
        state.LookupsTableLoading = true;
      }).addCase(getLookups.fulfilled, (state, action) => {
        state.LookupsButtonSpinner = false;
        state.LookupsTableLoading = false;
        state.LookupsResult = action.payload;
        state.tablePagination = {
            ...state.tablePagination,
            total: action.payload.pagination.total,
            current: action.payload.pagination.current_page,
            pageSize: action.payload.pagination.per_page
        };
      }).addCase(getLookups.rejected, (state, action) => {
        state.LookupsShowMessage = true; // Set the showMessage flag to display the errors
        state.LookupsButtonSpinner = false;
        state.LookupsTableLoading = false;
        state.LookupsErrors = JSON.parse(action.error.message); // Parse the error messages and store them in the state
      })
      .addCase(viewLookups.pending, (state, action) => {
        state.ViewLookupsLoader = true;
        state.ViewLookupsData = [];
      }).addCase(viewLookups.fulfilled, (state, action) => {
        state.ViewLookupsLoader = false;
        state.ViewLookupsData = action.payload;
      }).addCase(viewLookups.rejected, (state, action) => {
        state.ViewLookupsLoader = false;
        state.ViewLookupsData = [];
      })
      .addCase(deleteLookups.pending, (state, action) => {
        state.LookupsTableLoading = true;
      }).addCase(deleteLookups.fulfilled, (state, action) => {
        state.LookupsTableLoading = false;
      }).addCase(deleteLookups.rejected, (state, action) => {
        state.LookupsTableLoading = false;
      });
  },
});

export const { onCloseError, setColumnSearch, LookupsAddDrawerStatus, LookupsEditWithDrawerStatus, updateSortFilters } = manageLookupsSlice.actions;

export default manageLookupsSlice.reducer;